var _defs, _g, _polygon, _path, _polygon2, _path2, _polygon3, _polygon4, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRsWidthWht(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 225.88 142.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#eaeaea;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:#59595b;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 190.33,
    y1: 11.35,
    x2: 225.88,
    y2: 11.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#dbdbdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9e9e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 11.01,
    y1: 65.95,
    x2: 216.07,
    y2: 65.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -8654.05,
    y1: -2658.57,
    x2: -8618.5,
    y2: -2658.57,
    gradientTransform: "translate(-8618.35 -2538.62) rotate(180)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "200.12 6.56 199.96 19.24 190.25 13.35 190.41 0.66 200.12 6.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "190.33 0.66 225.88 1.02 225.76 22.04 213.19 14.45 202.9 8.25 190.33 0.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "225.76 22.04 225.8 34.72 215.91 28.82 216.07 16.14 225.76 22.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "200.14 6.56 216.07 16.14 26.94 125.33 11.01 115.75 200.14 6.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "216.07 16.14 215.91 28.82 27.5 138.02 26.94 125.33 216.07 16.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "35.7 130.64 35.7 143.62 0 142.96 0.16 130.28 35.7 130.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "35.7 130.64 0.16 130.28 0.27 109.26 12.85 116.85 23.13 123.05 35.7 130.64"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "77.41 52.85 75.83 53.76 73.22 52.47 73.22 52.38 75.35 51.15 76.62 51.83 77.88 49.69 80.01 48.46 80.01 48.57 77.41 52.85"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M80.28,60a2.27,2.27,0,0,1,1,2.22,6.36,6.36,0,0,1-1.23,3.66,10.11,10.11,0,0,1-3.32,3,6.08,6.08,0,0,1-2.64.91,2.06,2.06,0,0,1-1.81-.62,3,3,0,0,1-.64-2.1l2.6-1.5q0,2.4,2.49,1a4.59,4.59,0,0,0,1.44-1.26,2.61,2.61,0,0,0,.51-1.51c0-.56-.17-.89-.52-1a4.6,4.6,0,0,0-1.87.12,9.71,9.71,0,0,1-2.13.25A2,2,0,0,1,72,60.78a5.63,5.63,0,0,1,.56-2.41A8.88,8.88,0,0,1,74.24,56a10.74,10.74,0,0,1,2.41-1.9,5.55,5.55,0,0,1,2.41-.83,1.91,1.91,0,0,1,1.63.64,3,3,0,0,1,.59,2l-2.59,1.5c0-.66-.18-1.07-.55-1.23a1.76,1.76,0,0,0-1.52.33,4.35,4.35,0,0,0-1.48,1.32,2.65,2.65,0,0,0-.52,1.51.74.74,0,0,0,.62.83A4.9,4.9,0,0,0,77.06,60,4.84,4.84,0,0,1,80.28,60Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "85.77 49.01 85.81 63.44 83.23 64.93 83.19 50.5 85.77 49.01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95.26,51.94,98,56.27v.14L95.21,58l-2.36-3.93-2.07,1.19,0,5.28-2.59,1.5,0-14.43,4.66-2.7c1.49-.86,2.63-1.13,3.44-.84s1.21,1.14,1.22,2.52a7.05,7.05,0,0,1-.55,2.79A9,9,0,0,1,95.26,51.94Zm-.89-1.71a3.55,3.55,0,0,0,.53-1.88q0-1-.51-1.32c-.34-.19-.85-.09-1.55.31l-2.08,1.2,0,4.33,2.08-1.2a4.19,4.19,0,0,0,1.51-1.44"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "102.19 39.53 102.23 53.96 99.65 55.45 99.61 41.02 102.19 39.53"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "114.8 32.25 114.84 46.68 112.26 48.17 107.19 41.59 107.22 51.08 104.63 52.58 104.59 38.14 107.18 36.65 112.25 43.25 112.22 33.74 114.8 32.25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M123.23,27.38,128,39.1l-2.75,1.59-.88-2.47-4.54,2.62L119,44.31,116.2,45.9l4.64-17.13ZM120.5,38l3.13-1.81L122,31.72,120.5,38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsWidthWht);
export default __webpack_public_path__ + "static/media/rs-width-wht.9493918c6d76972c90368c24152e1c30.svg";
export { ForwardRef as ReactComponent };